import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.scss";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { ProjectContext } from "./utils/projectContext.js";

function App() {
  const [text, setText] = useState(Boolean);
  const [unactive, setUnactive] = useState(Boolean);
  const [fontStyle, setFontStyle] = useState({});
  const [fontStyleBtn, setFontStyleBtn] = useState([]);
  const [layerCount, setLayerCount] = useState([{}]);
  const [layerNow, setLayerNow] = useState(0);
  const [imgs, setImgs] = useState([]);
  const [save, setSave] = useState(false);
  const [checkObj, setCheckObj] = useState({});
  const [projectArr, setProjectArr] = useState([]);
  const [projectNow, setProjectNow] = useState({});
  const [changeName, setChangeName] = useState(false);
  const [showDynamic, setShowDynamic] = useState(false);
  const [dynamic, setDynamic] = useState(false);
  const [cars, setCars] = useState({
    carType: "",
    numberType: "",
  });
  const [customTypeName, setCustomTypeName] = useState("");
  const [showData, setShowData] = useState(false);
  const [customTypeNameArr, setCustomTypeNameArr] = useState([]);
  const [newZone, setNewZone] = useState({});
  const [showZone, setShowZone] = useState(false);
  const [customFeatures, setCustomFeatures] = useState(
    JSON.parse(localStorage.getItem("customFeatures")) || []
  );
  const [activeSecondKey, setActiveSecondKey] = useState("");
  const [activeKey, setActiveKey] = useState(["0"]);
  const [showFont, setShowFont] = useState(false);
  const [category, setCategory] = useState("");
  const [iconExclusivity, setIconExclusivity] = useState(false);
  const [showIconExclusive, setShowIconExclusive] = useState(false);
  const [imageStyles, setImageStyles] = useState({
    left: "",
    top: "",
    angle: "",
    width: "",
    height: "",
  });
  const [newCanvas, setNewCanvas] = useState(false);
  const [newCanvasName, setNewCanvasName] = useState("");
  const [newApiName, setNewApiName] = useState("");
  const [showLeftArrow, setShowLeftArrow] = useState(true);
  const [screenshot, setScreenshot] = useState(false);
  const [classNow, setClassNow] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [selectedIcons, setSelectedIcons] = useState([]);
  const [iconsNow, setIconsNow] = useState([]);
  const [showIcons, setShowIcons] = useState(false);
  const [newDuplicateIcons, setNewDuplicateIcons] = useState([]);
  // 显示智翎云境
  const [showCloudCity, setShowCloudCity] = useState(false);
  // 控制是否下载JSON文件
  const [shouldDownloadJson, setShouldDownloadJson] = useState(true);
  // 保存完成后的回调函数
  const [saveCallback, setSaveCallback] = useState(null);
  // 画布层级
  // const [currentIndex, setCurrentIndex] = useState(0);

  window.onbeforeunload = function () {
    localStorage.removeItem("canvasArr");
  };
  return (
    <ProjectContext.Provider
      value={{
        text,
        setText,
        unactive,
        setUnactive,
        fontStyle,
        setFontStyle,
        fontStyleBtn,
        setFontStyleBtn,
        layerCount,
        setLayerCount,
        layerNow,
        setLayerNow,
        imgs,
        setImgs,
        save,
        setSave,
        checkObj,
        setCheckObj,
        projectArr,
        setProjectArr,
        projectNow,
        setProjectNow,
        changeName,
        setChangeName,
        showDynamic,
        setShowDynamic,
        dynamic,
        setDynamic,
        cars,
        setCars,
        customTypeName,
        setCustomTypeName,
        showData,
        setShowData,
        customTypeNameArr,
        setCustomTypeNameArr,
        newZone,
        setNewZone,
        showZone,
        setShowZone,
        customFeatures,
        setCustomFeatures,
        activeSecondKey,
        setActiveSecondKey,
        showFont,
        setShowFont,
        category,
        setCategory,
        iconExclusivity,
        setIconExclusivity,
        showIconExclusive,
        setShowIconExclusive,
        imageStyles,
        setImageStyles,
        newCanvas,
        setNewCanvas,
        newCanvasName,
        setNewCanvasName,
        newApiName,
        setNewApiName,
        showLeftArrow,
        setShowLeftArrow,
        screenshot,
        setScreenshot,
        activeKey,
        setActiveKey,
        classNow,
        setClassNow,
        dialogOpen,
        setDialogOpen,
        addOpen,
        setAddOpen,
        selectedIcons,
        setSelectedIcons,
        iconsNow,
        setIconsNow,
        showIcons,
        setShowIcons,
        newDuplicateIcons,
        setNewDuplicateIcons,
        showCloudCity,
        setShowCloudCity,
        shouldDownloadJson,
        setShouldDownloadJson,
        saveCallback,
        setSaveCallback,
        // currentIndex,
        // setCurrentIndex
      }}
    >
      <RouterProvider router={router} />
    </ProjectContext.Provider>
  );
}

export default App;
